<div class="p-30 pb-10">
  <h4 mat-dialog-title>{{ data.heading }}</h4>

  @if(data?.img) {
  <img [src]="data.img" alt="img" class="img-fluid" />
  }
  <p class="text-center" mat-dialog-content>
    {{ data.dialogContext }}
  </p>

  <div mat-dialog-actions class="dialog-actions">
    <button
      mat-flat-button
      mat-dialog-close
      (click)="close()"
      class="border-none fw-semibold ps-30 pe-30 pt-12 cursor-pointer dialog-cancel-button"
    >
      {{ "cancel.capitalize" | translate }}
    </button>
    <button
      mat-flat-button
      [color]="color"
      mat-dialog-close
      (click)="confirm()"
      class="border-none fw-semibold ps-30 pe-30 pt-12 cursor-pointer dialog-confirm-button"
    >
      {{ "confirm.capitalize" | translate }}
    </button>
  </div>
</div>
